import React from 'react';
import { path } from 'ramda';
import PropTypes from 'prop-types';
import UiComponent from '../UiComponent';

export default class Select extends UiComponent {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
    this.buildOptions = this.buildOptions.bind(this);
    this.getSource = this.getSource.bind(this);
  }

  getSource() {
    if (this.props.field && this.props.field.source) {
      return this.props.field.source;
    } else {
      return this.props.options;
    }
  }

  buildOptions() {
    const arrOptions = [];
    const source = this.getSource();

    for (let i = 0; i < source.length; i++) {
      const currentOption = source[i];
      let value = path(['field', 'value'], this.props) || '';
      let selected = false;

      if (currentOption.value == value) {
        selected = true;
      }

      if (!selected && currentOption.text && currentOption.text.toLowerCase() == String(value).toLowerCase()) {
        selected = true;
      }

      arrOptions.push(
        <option key={i} selected={selected} value={currentOption.value}>{currentOption.label ? currentOption.label : currentOption.text}</option>
      );
    }

    return arrOptions;
  }

  changeValue(value) {
    this.props.field.value = value;
    //const field = {...this.props.field};
    //field.value = value;
    this.props.onChange(this.props.field.name, this.props.field);
  }

  render() {
    let { placeholder = '' } = this.props;
    if (placeholder === '') {
      placeholder = typeof this.props.field.placeholder != 'undefined' ? this.props.field.placeholder : '' ;
    }

    const containerClass = `form-group ${this.props.className}`;
    return (
      <div className={containerClass}>
        {this.getLabel()}
        <select placeholder={placeholder} className="custom-select col-12" onChange={e => this.changeValue(e.target.value)} disabled={this.props.disabled}>
          {!this.props.field.value && <option value="">{placeholder}</option>}
          {this.buildOptions()}
        </select>
        {this.getErrors()}
      </div>
    );
  }
}

Select.propTypes = {
  className: PropTypes.string,
  options: PropTypes.array,
  field: PropTypes.object,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/common/Select/index.js